import React, { useRef } from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { DivisionCard } from '../../cards';
import { isMobileDevice } from '../../../utils/misc';
import { pluralize } from '../../../utils/formatting';
import { eventDivisionIsPlatformPaymentOrFree, getRegisteredCountDisplay } from '../../../utils/events';
import { ANNUAL_POWER_ONLY_LABEL } from '../../../utils/eventConstants';
import BallType from '../../text/BallType';

const DivisionList = (props) => {
    const { auth, showPlayers, isPaidHitEvent, isPaidHitterRegistered, isCurrentMemberAdmin, clubVerificationFee, handleDivisionClick } = props;
    const { data: event } = props.events.currentEvent;
    const { acceptance } = props.events.currentEvent;
    let sliderRef = useRef(null);
    const wrapperRef = useRef(null);
    let maxItems = 1;

    if (sliderRef.current) {
        maxItems = Math.round(432 / sliderRef.current.innerSlider.list.firstChild.firstChild.offsetHeight);
        if (sliderRef.current.innerSlider.list.firstChild.children.length < maxItems) {
            maxItems = sliderRef.current.innerSlider.list.firstChild.children.length;
        }
    }

    const responsive = [{ breakpoint: 1200, settings: { slidesToShow: 4 } }];
    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: maxItems,
        slidesToScroll: 1,
        responsive,
        arrows: true,
        autoplay: false,
        // afterChange: handleChange,
        initialSlide: 0,
        autoplaySpeed: 0,
        vertical: true,
        verticalSwiping: true,
    };

    const getRegisteredPlayersText = (division) => {
        const { maxPlayers, registeredCount, divisionFormatTypeId } = division;
        const isAcceptanceList = acceptance?.[division.id] && !acceptance?.[division.id].error;
        const registeredCountDisplay = getRegisteredCountDisplay(registeredCount, divisionFormatTypeId, isPaidHitEvent, isPaidHitterRegistered);
        const showRegisteredText = !(isCurrentMemberAdmin && isPaidHitEvent && isPaidHitterRegistered);

        if (registeredCountDisplay && registeredCountDisplay > 0) {
            const playerCountText = maxPlayers ? `${registeredCountDisplay}/${maxPlayers}` : registeredCountDisplay;

            if (division.registered) {
                const registrationStatus = showRegisteredText ? ' - You\'re registered!' : '';
                const verb = isAcceptanceList ? 'registered' : 'playing';
                return `${playerCountText} ${verb}${registrationStatus}`;
            }
            return `${playerCountText} registered`;
        }
        return '';
    };

    function renderDivisionCards() {
        return (
            event.eventDivisions.map((division, i) => (
                <div key={i}>
                    {(event.workflowVersion > 1 && clubVerificationFee > 0) ? (
                        <DivisionCard
                            user={auth.user}
                            eventUtrType={event.utrType.value}
                            division={division}
                            showPlayers={showPlayers}
                            className={`${division.registered ? 'registered' : ''}`}
                            registeredPlayersText={getRegisteredPlayersText(division)}
                            onClick={event.eventState.registrationState.value === 'open_registration' ? handleDivisionClick : null}
                            showFooter={false}
                            workflowVersion={event.workflowVersion}
                            showDetails={false}
                            clubVerificationFee={clubVerificationFee}
                            allowOffPlatformPayments={event.allowOffPlatformPayments}
                            isPaidHitEvent={isPaidHitEvent}
                            isPaidHitterRegistered={isPaidHitterRegistered}
                        />
                    ) : (
                        <div
                            className={`division-card cursor-unset ${division.registered ? 'registered' : ''}`}
                        >
                            <div className="details row no-gutters">
                                <div className="col-12 h6">{division.name}
                                    <span className="price float-right">
                                        {division.price}
                                    </span>
                                </div>
                                <div className={`col-${!eventDivisionIsPlatformPaymentOrFree(division) ? '8' : '12'} description`}>
                                    {(!!division.ballType) && <BallType ballType={division.ballType} />}
                                    {division.annualPoweredOnly && <span className="text-bold text-small">{ANNUAL_POWER_ONLY_LABEL}<br /></span>}
                                    {showPlayers ? getRegisteredPlayersText(division) : division.registered ? 'You’re playing' : ''}
                                </div>
                                {!eventDivisionIsPlatformPaymentOrFree(division) && (
                                    <div className="col-4 text-right text-teal description">
                                        Fee Due in Your Country`s Currency
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            ))
        );
    }

    return (
        <div className="divisions">
            <div className="divisions-title-wrapper d-block d-sm-none">
                <div className="divisions-title">
                    <p className="text-highlight2 text-uppercase mb0">
                        {`${event.eventDivisions.length} ${pluralize('Division', event.eventDivisions.length)}`}
                    </p>
                    <div className="divisions-title-bg" />
                </div>
            </div>
            {(event.eventDivisions.length < 3 || isMobileDevice()) && (
                <div className="divisions-wrapper">
                    {renderDivisionCards()}
                </div>
            )}
            {(event.eventDivisions.length > 2 && !isMobileDevice()) && (
                <div className="divisions-wrapper" ref={wrapperRef}>
                    <Slider
                        {...sliderSettings}
                        // eslint-disable-next-line no-return-assign
                        ref={c => sliderRef = c}
                    >
                        {renderDivisionCards()}
                    </Slider>
                </div>
            )}
        </div>
    );
};

function mapStateToProps({ auth, events }) {
    return { auth, events };
}

export default connect(mapStateToProps, null)(DivisionList);
